__turbopack_context__.v({
  "contentWrapper": "MAk5ca_contentWrapper",
  "countryButton": "MAk5ca_countryButton",
  "countryGrid": "MAk5ca_countryGrid",
  "countryItem": "MAk5ca_countryItem",
  "globalButton": "MAk5ca_globalButton",
  "globalLabel": "MAk5ca_globalLabel",
  "globalSection": "MAk5ca_globalSection",
  "groupTitle": "MAk5ca_groupTitle",
  "languageLink": "MAk5ca_languageLink",
  "languageOptions": "MAk5ca_languageOptions",
  "noResults": "MAk5ca_noResults",
  "pageTitle": "MAk5ca_pageTitle",
  "pageWrapper": "MAk5ca_pageWrapper",
  "regionGroupSection": "MAk5ca_regionGroupSection",
  "searchWrapper": "MAk5ca_searchWrapper",
});
